import React from "react";
import Flap from "./Flap";
import { faBell, faBellSlash } from "@fortawesome/pro-solid-svg-icons";
import StatusNotification from "../../../global/notification/StatusNotification";
import { useNotification } from "../../../redux/notifications/hooks";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import EmptyState from "../../../global/common/EmptyState";
import { colors } from "../../../utils";
import {
  TextVariant,
  TypographyNew,
} from "../../../global/typography/typography";
import { flapOut } from "../../../utils/z-index";
import { NotificationDto } from "../../../redux/api-model/topbar/notifications";
import { NotificationCardData } from "../../../global/notification/notification";

export const NotificationsFlag = styled.div`
  width: 8px;
  height: 8px;
  background-color: red;
  position: absolute;
  z-index: ${flapOut};
  border-radius: 8px;
  top: 7px;
  right: 12px;
`;

const NotificationFlapContainer = styled.div`
  position: relative;
`;

const PreviousNotifications = styled.div`
  padding: 20px;
  border-bottom: 1px solid ${colors.gray14};
  &:first-child {
    margin-top: 10px;
  }
  &:last-child {
    border-bottom: none;
  }
  text-align: center;
`;

function getNotificationCardData(
  notification: NotificationDto
): NotificationCardData {
  const {
    type,
    metadata,
    subjectFirstName,
    subjectUserUid,
    subjectLastName,
    absenceRequestDuration,
    absenceRequestIcon,
  } = notification;

  return {
    firstName: subjectFirstName,
    lastName: subjectLastName,
    id: subjectUserUid ? subjectUserUid : "0",
    employeeId: metadata?.subjectEmployeeUuid,
    workContractId: metadata?.subjectWorkContractUuid,
    event: {
      type,
      absenceRequestIcon,
      absenceRequestDuration,
      endDate: metadata?.endDate,
      startDate: metadata?.startDate,
      absenceType: metadata?.absenceType,
    },
  };
}

const NotificationFlap = (): JSX.Element => {
  const { content, hasUnRead, clearNotifications } = useNotification();
  const { t } = useTranslation("notifications");
  const noNotifications = useTranslation("top-bar").t("topbar.noNotifications");
  const unread = content.filter((c) => !c.readOrSentAt);
  const read = content.filter((c) => !!c.readOrSentAt);

  return (
    <NotificationFlapContainer>
      {hasUnRead ? <NotificationsFlag /> : null}
      <Flap onClose={clearNotifications} icon={faBell}>
        <>
          {unread.length ? (
            unread.map((notification, id) => {
              const { type, body, title, creationDate } = notification;

              return (
                <StatusNotification
                  type={type}
                  title={t(title)}
                  data={getNotificationCardData(notification)}
                  body={t(body)}
                  key={id}
                  date={creationDate}
                />
              );
            })
          ) : (
            <EmptyState icon={faBellSlash} message={noNotifications} />
          )}
          {read.length > 0 && (
            <>
              <PreviousNotifications>
                <TypographyNew variant={TextVariant.caption}>
                  {t("notification.previous")}
                </TypographyNew>
              </PreviousNotifications>
              <>
                {read.map((notification, id) => {
                  const { type, body, title, creationDate } = notification;

                  return (
                    <StatusNotification
                      type={type}
                      title={t(title)}
                      data={getNotificationCardData(notification)}
                      body={t(body)}
                      key={id}
                      date={creationDate}
                    />
                  );
                })}
              </>
            </>
          )}
        </>
      </Flap>
    </NotificationFlapContainer>
  );
};

export default NotificationFlap;
